/* eslint-disable class-methods-use-this */
define(
  'marqueeArrowsHandler',[
  ],
  () => {
    'use strict';

    class ArrowHandler {
      constructor(configObject) {
        this.config = configObject;
        this.handleNavigationControls();
      }

      /**
     * Notifies imageSelected subscribers that a new image has been selected.
     * @param {Object} activeImage MarqueeGalleryItem object
     */
      notifyChange(action) {
        this.config.eventOnThumbSelected(action);
      }

      navigateToImage(event) {
        const action = event.target.dataset.filmstripButton;
        this.notifyChange(action);
      }

      handleNavigationControls() {
        this.config.navigationButtons.forEach((button) => {
          button.addEventListener('click', this.navigateToImage.bind(this));
        });
      }
    }

    return ArrowHandler;
  }
);

